// extracted by mini-css-extract-plugin
export default {"addButtons":"Documents_addButtons__IVByJ","addDocumentButton":"Documents_addDocumentButton__rqXdr"};